export const BRAND_LOCALES_MAP = {
    cwjobs: ['en-GB'],
    totaljobs: ['en-GB'],
    jobsite: ['en-GB'],
    milkround: ['en-GB'],
    caterer: ['en-GB'],
    cityjobs: ['en-GB'],
    justengineers: ['en-GB'],
    emedcareers: ['en-GB'],
    retailchoice: ['en-GB'],
    catererglobal: ['en-GB'],
    careerstructure: ['en-GB'],
    stepstonede: ['en-DE', 'de-DE'],
    stepstoneat: ['en-AT', 'de-AT'],
    stepstonebe: ['en-BE', 'fr-BE', 'nl-BE'],
    stepstonenl: ['en-NL', 'nl-NL'],
    pnet: ['en-ZA'],
    nijobs: ['en-GB'],
    irishjobs: ['en-GB'],
    jobsie: ['en-GB'],
};
//# sourceMappingURL=translations.js.map